module.exports = __webpack_public_path__ + "media/images/icons/arrow_left-c0c79b4f700c31de4e30ff0af87548e4.svg";